<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Work Management" title="Job Logs" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
							<div class="row mb-4">
								<div class="col-md-12 float-end">
									<router-link to="/job_management" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i>Back</router-link>
							    </div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-10 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchJobLogs()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1 float-end" placeholder="Search" v-model="keyword" @keyup="fetchJobLogs()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>User</th>
											<th>Action</th>
											<th>Date</th>
											<th>User Type</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(work_logs.length)">
										<tr align="center" v-for="(work_log, index) in work_logs" :key="index">
                                            <td>{{ (from - 1) + index + 1 }}</td>
											<td>
												{{ work_log.user_name }}
											</td>
											<td>{{ work_log.action }}</td>
											<td>{{ proxy.$filters.convertDate(work_log.date) }}</td>
											<td>{{ work_log.user_type }}</td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="9" class="text-center">No work logs found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<div class="row mt-2">
								<div class="col-md-6">
									<p class="text-muted mb-0">
										Showing {{ from || 0 }} to {{ to || 0 }} of {{ total || 0 }} entries
									</p>
								</div>
								<div class="col-md-6">
									<nav aria-label="Page navigation">
										<ul class="pagination justify-content-end">
											<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
												<a class="page-link" href="#" @click.prevent="fetchJobLogs(page.url)" tabindex="-1">
													<span v-if="index === 0">Prev</span>
													<span v-else-if="index === pagination.length - 1">Next</span>
													<span v-else v-html="page.label"></span>
												</a>
											</li>
										</ul>
									</nav>
								</div>
							</div>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { onMounted, ref, getCurrentInstance } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { routes } from '@/constants/routes';
import { get } from '@/utils/api';
import Swal from '@/utils/swal';

const router = useRouter();
const { proxy } = getCurrentInstance();
const route = useRoute();
const work_logs = ref([]);
const listing_length = ref(10);
const keyword = ref("");
const from = ref(null);
const to = ref(null);
const total = ref(null);
const pagination = ref({});

const fetchJobLogs = (url = null) => {

	const params = {
        limit: listing_length.value,
        job_id: route.query.id,
		keyword: keyword.value
	}

	const requestUrl = url ?? routes.JobLogs;

	get(requestUrl, { params }, false)
		.then((response) => {
			if(response.status === 200){
				console.log(response.data.data);
				work_logs.value = response.data.data.logs.data;
				pagination.value = response.data.data.logs.links;
				from.value = response.data.data.logs.from;
				to.value = response.data.data.logs.to;
				total.value = response.data.data.logs.total;
			} else {
				Swal.fire('', response.data.message || 'Failed to fetch job logs', 'error');
			}
		})
		.catch((error)	=> {
			if (error.response?.status === 422) {
				Swal.fire('', error.response.data.message.limit?.[0] || error.response.data.message.status?.[0] || error.response.data.message.keyword?.[0] || 'Validation error', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

onMounted(() => {
	fetchJobLogs();
})

</script>